import { useNavigate } from "react-router-dom";
import { FormEvent, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import {
  Button,
  IconButton,
  InputAdornment,
  Tooltip,
  useMediaQuery,
} from "@mui/material";

import LogoBlack from "logo/GRACE_LOGO_V4_BLACK.png";
import LogoWhite from "logo/GRACE_LOGO_V4_WHITE.png";
import { useAuth } from "components/auth/AuthProvider";
import { useUserServiceLocalSignin } from "hooks/user/base";

export const SigninLocal = () => {
  const darkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const { auth } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword(!showPassword);

  const signin = useUserServiceLocalSignin();

  const handleLogin = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // attempt signin
    signin.mutate({ email, password });
  };

  useEffect(() => {
    if (auth) navigate("/");
  }, [auth]);

  useEffect(() => {
    document.title = "GRACE | local | signin";
  }, []); // run once on mount

  return (
    <Container
      maxWidth="xs"
      component="main"
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        marginBlock: "auto",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        {darkMode ? (
          <img src={LogoWhite} alt="Logo 2" className="logo" />
        ) : (
          <img src={LogoBlack} alt="Logo 1" className="logo" />
        )}
      </div>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Avatar sx={{ mb: 4, bgcolor: "secondary.main" }}>
          <LockOutlinedIcon />
        </Avatar>

        <Box component="form" onSubmit={handleLogin} noValidate>
          <TextField
            // variant="standard"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            onChange={(e: any) => setEmail(e.target.value)}
            autoComplete="email"
            autoFocus
          />

          <TextField
            // variant="standard"
            margin="normal"
            required
            fullWidth
            id="password"
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            onChange={(e: any) => setPassword(e.target.value)}
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={toggleShowPassword}
                    aria-label="toggle password visibility"
                  >
                    {showPassword ? (
                      <VisibilityOffOutlinedIcon />
                    ) : (
                      <VisibilityOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={!(email && password)}
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>

          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs textAlign="left">
              <Tooltip title="SSO">
                <IconButton href="/signin">
                  <MicrosoftIcon color="inherit" fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid item xs textAlign="right">
              <Link
                href="/local/signup"
                color="inherit"
                variant="body2"
                underline="none"
              >
                Sign up
              </Link>
            </Grid>

            {/* <Grid item xs textAlign="right">
              <Link
                // href="/local/forgot-password"
                color="inherit"
                variant="body2"
                underline="none"
              >
                Forgot password
              </Link>
            </Grid> */}
          </Grid>
        </Box>
      </Box>

      {/* <Box
        left={4}
        // bottom={8}
        fontSize="small"
        position="absolute"
      >
        <IconButton href="/signin">
          <MicrosoftIcon color="inherit" fontSize="small" />
        </IconButton>
      </Box> */}
    </Container>
  );
};
